import getSystemType from '@hooks/systemType/getSystemType';

const useGetSystemType = ({ enabled }) => getSystemType({ enabled });

export default useGetSystemType;
